import { FC, useState } from 'react'

import { SequenceMenu } from '@sequencehq/core-components'

import { LinkAliasToCustomerModal } from '../modals/LinkAliasToCustomer/LinkAliasToCustomer.modal'

export const LinkToCustomerMenuItem: FC<{
  testIdPrefix: string
  eventId: string
  alias: string
  onClose: () => void
  onSuccess: () => void
}> = ({ testIdPrefix, eventId, alias, onClose, onSuccess }) => {
  const [showModal, setShowModal] = useState(false)

  return (
    <>
      <SequenceMenu.Item
        key="link-to-customer"
        uuid="link-to-customer"
        label="Link to an existing customer"
        data-testid={`${testIdPrefix}.${eventId}.menuItem.linkToCustomer`}
        onClick={e => {
          e.stopPropagation()
          setShowModal(true)
        }}
      />
      {showModal && (
        <LinkAliasToCustomerModal
          alias={alias}
          onClose={onClose}
          onSuccess={onSuccess}
        />
      )}
    </>
  )
}
